<template>
  <div class="part">
    <p class="input-filter-label">
      {{ inputTextTitle }}
      
      <slot />
      
    </p>
    <div
      class="input-wrapper input-field"
      :class="{'error-input' : errors.has(inputErrorsName)}"
    >
      <input
        type="text"
        :name="inputName"
        class="input"
        :placeholder="inputPlaceholder"
        :value="inputValue"
        v-validate="'required|min:1|max:' + maxLength"
        :data-vv-scope="inputTextScopeValidation.length ? inputTextScopeValidation : false"
        @input="inputTextValue"
        @focus.self="clearInputErrorsText"
        @blur="clearOthersText"
      />
      
      <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon">
      
      <div
        v-show="errors.has(inputErrorsName)"
        class="error-tooltip"
        :class="{'hide-tooltip' : bluredProp !== inputName}"
      >
        <div class="text">
          {{ errors.first(inputErrorsName) }}
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
  export default {
    name: "FPInputText",
    inject: ['$validator'],
    props: {
      inputTextTitle: {
        type: String,
        required: true
      },
      inputName: {
        type: String,
        required: true
      },
      inputErrorsName: {
        type: String,
        required: true
      },
      inputPlaceholder: {
        type: String,
        required: true
      },
      inputValue: {
        type: String,
        required: true
      },
      bluredProp: {
        type: String,
        required: true
      },
      inputTextScopeValidation: {
        type: String,
        default: ''
      },
      maxLength: {
        type: Number,
        required: false
      }
    },
    methods: {
      inputTextValue (e) {
        this.$emit('inputTextValue', e.target.value);
      },
      clearInputErrorsText (e) {
        if (this.inputTextScopeValidation) {
          this.errors.remove(this.inputTextScopeValidation + '.' + e.target.name);
        }
        this.$emit('clearInputErrorsText', e);
      },
      clearOthersText (e) {
        this.$emit('clearOthersText', e);
      }
    }
  }
</script>

